$(function () {
  // show more description in property
  $(".js-show-more").on("click", function () {
    var content = this.closest(".js-description").querySelector(
      ".js-description-content"
    );

    content.style.maxHeight = content.classList.contains("is-show")
      ? "232px"
      : content.scrollHeight + "px";
    content.classList.toggle("is-show");

    $(this).toggleClass("active");
  });

  // related tour slider init
  $(".js-related-tour-slider").owlCarousel({
    loop: false,
    rtl: true,
    margin: 24,
    nav: true,
    dots: false,
    // autoplay: true,
    autoplayHoverPause: true,
    autoWidth: false,
    responsive: {
      0: {
        items: 2.5,
        margin: 8,
      },
      993: {
        items: 4,
        margin: 20,
      },
    },
  });

  //popular-destinations slider
  $(".js-popular-destinations").owlCarousel({
    loop: false,
    margin: 22,
    rtl: true,
    responsiveClass: true,
    autoWidth: false,
    dots: true,
    responsive: {
      0: {
        items: 2,
        margin: 8,
        autoWidth: true,
      },
      768: {
        items: 4,
        autoWidth: false,
      },
      1320: {
        items: 5,
        nav: true,
      },
    },
  });

  //tour-slider slider
  $(".js-tour-slider").owlCarousel({
    loop: false,
    margin: 8,
    rtl: true,
    responsiveClass: true,
    autoWidth: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
      },
      768: {
        items: 3,
        autoWidth: false,
      },
      1180: {
        nav: true,
        margin: 24,
      },
    },
  });
});
